module.exports = __webpack_public_path__ + "img/emoji_6.f5e47987.png";